<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="card">
    <p-accordion multiple="true" (activeIndexChange)="handleOnOpen($event)">
        <!-- <p-accordionTab header="Update Multiple Users">

        </p-accordionTab> -->
        <p-accordionTab header="Users" [selected]="true" [disabled]="true">
            <ng-template #header>
                <span>Users</span>
            </ng-template>
            <div class="pb-1">
                <ef-manage-users-bulk-update-presenter
                    [userInfo]="userInfo$ | async"
                    [daysOfWeek]="daysOfWeek$ | async"
                    [costCenters]="costCenters$ | async"
                    [timeZones]="timeZonesSelectItems$ | async"
                    [userIdFormats]="userIdFormats$ | async"
                    [updateEnabled]="bulkUpdateEnabled$ | async"
                    (UpdateBulkLogins)="UpdateBulkLoginsSubject.next($event)"
                ></ef-manage-users-bulk-update-presenter>
            </div>

            <ef-manage-users-presenter
                [qboEnabled]="qboEnabled$ | async"
                [height]="tabHeight"
                [items]="ManageUsersModel$ | async"
                [loading]="ManageUsersModelDS.loading$ | async"
                [selectedError]="selectedErrorWithStatus$ | async"
                [userInfo]="userInfo$ | async"
                [supervisors]="supervisors$ | async"
                [timeZones]="timeZonesSelectItems$ | async"
                [splitdays]="splitdays$ | async"
                [costCenters]="costCenters$ | async"
                [daysOfWeek]="daysOfWeek$ | async"
                [serviceItems]="serviceItems$ | async"
                [activeServiceItems]="activeServiceItems$ | async"
                [payrollItems]="payrollItems$ | async"
                [mobileProviders]="mobileProviders$ | async"
                [creditCards]="creditCards$ | async"
                [messageDeliveryTypes]="messageDeliveryTypes$ | async"
                [payrollFrequency]="payrollFrequency$ | async"
                [emailEnabled]="emailEnabled$ | async"
                [userTypes]="userTypes$ | async"
                [updateBulkLogins]="UpdateBulkLoginsSubject.asObservable() | async"
                (SelectItem)="onSelectUsers($event)"
                (SendCredentials)="onSendCredentials($event)"
                (ShowError)="ShowErrorSubject.next($event)"
                (SaveItem)="SaveLoginSubject.next($event[0])"
                (ShowInactive)="ShowInactiveSubject.next($event)"
            ></ef-manage-users-presenter>
        </p-accordionTab>
    </p-accordion>
</div>

